(() => {
	const SELECTORS = {
		openSearch: '[data-kx-open-search]',
		drawerToggle: '#nav-drawer [data-drawer-toggle]',
	};

	function openKimonixSearch() {
		const open = window.KXChatAgent?.openModal;
		if (typeof open === 'function') {
			open();
			return true;
		}

		const bubble = document.getElementById('kxChatSearchBubbleBtn');
		if (bubble) {
			bubble.click();
			return true;
		}

		return false;
	}

	function closeNavDrawer() {
		const drawer = document.getElementById('nav-drawer');
		if (!drawer?.classList.contains('is-open')) return;

		const closeBtn = drawer.querySelector(SELECTORS.drawerToggle);
		if (closeBtn) {
			closeBtn.click();
			return;
		}

		drawer.classList.remove('is-open');
		document.documentElement.classList.remove('js-drawer-open');
		document.body.classList.remove('js-drawer-open');
	}

	function onOpenSearch(event) {
		event.preventDefault();
		closeNavDrawer();

		if (openKimonixSearch()) return;

		// Kimonix script may still be loading
		let tries = 0;
		const timer = setInterval(() => {
			tries += 1;
			if (openKimonixSearch() || tries > 20) clearInterval(timer);
		}, 100);
	}

	function init() {
		document.querySelectorAll(SELECTORS.openSearch).forEach((el) => {
			el.addEventListener('click', onOpenSearch);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
